import React from 'react'

export default function GlobalSearchResult ({
  id,
  title,
  excerpt,
  permalink,
  tagline
}) {
  return (
    <a href={permalink} className="global-search__result" data-id={id}>
      {tagline && (<div className="global-search__result-tagline tagline">{tagline}</div>)}
      {title && (<h3 className="global-search__result-title" dangerouslySetInnerHTML={{ __html: title }}/>)}
      {excerpt && (<div className="global-search__result-excerpt wysiwyg">{excerpt}</div>)}
    </a>
  )
}